// app/src/pages/Home.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import DiscordInvite from '../components/DiscordInvite';
import Logo from '../components/Logo';

const Home = () => {
  const styles = {
    homePage: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '2rem'
    },
    section: {
      marginBottom: '4rem'
    },
    heroSection: {
      textAlign: 'center',
      padding: '4rem 0'
    },
    logoContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '2rem'
    },
    heroTitle: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      marginBottom: '1.5rem',
      color: '#2d3748'
    },
    heroSubtitle: {
      fontSize: '1.25rem',
      color: '#4a5568',
      marginBottom: '2rem',
      lineHeight: '1.8'
    },
    ctaContainer: {
      display: 'flex',
      gap: '1rem',
      justifyContent: 'center'
    },
    button: {
      padding: '0.75rem 1.5rem',
      borderRadius: '0.375rem',
      fontWeight: '600',
      cursor: 'pointer',
      textDecoration: 'none',
      display: 'inline-block'
    },
    primaryButton: {
      backgroundColor: '#4299e1',
      color: 'white',
      border: 'none'
    },
    secondaryButton: {
      backgroundColor: 'transparent',
      border: '2px solid #4299e1',
      color: '#4299e1'
    },
    sectionTitle: {
      fontSize: '2rem',
      fontWeight: 'bold',
      marginBottom: '1.5rem',
      color: '#2d3748'
    },
    sectionText: {
      fontSize: '1.1rem',
      color: '#4a5568',
      lineHeight: '1.7',
      marginBottom: '1rem'
    },
    featuresGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '2rem',
      marginTop: '2rem'
    },
    featureItem: {
      padding: '1.5rem',
      backgroundColor: '#f7fafc',
      borderRadius: '0.5rem'
    },
    featureTitle: {
      fontSize: '1.25rem',
      fontWeight: '600',
      marginBottom: '0.75rem',
      color: '#2d3748'
    },
    ctaNote: {
      marginTop: '2rem',
      fontSize: '0.875rem',
      color: '#718096',
      textAlign: 'center'
    }
  };

  return (
    <div style={styles.homePage}>
      {/* Hero Section */}
      <section style={{...styles.section, ...styles.heroSection}}>
        <div style={styles.logoContainer}>
          <Logo size="xlarge" showText={false} />
        </div>
        <h1 style={styles.heroTitle}>
          Streamline Your Game Night!
        </h1>
        <p style={styles.heroSubtitle}>
          Get instant answers to gaming questions, from setup guides to complex rule clarifications. 
          Whether you're a first-time player or encountering edge cases, we're here to help you keep playing.
        </p>
        <div style={styles.ctaContainer}>
          <Link to="/ask" style={{...styles.button, ...styles.primaryButton}}>
            Get Started
          </Link>
          <Link to="/about" style={{...styles.button, ...styles.secondaryButton}}>
            Learn More
          </Link>
        </div>
      </section>

      {/* About Section */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>About This Project</h2>
        <p style={styles.sectionText}>
          Born from a lifelong passion for gaming and cutting-edge technology, this platform combines 
          the power of AWS cloud computing and AI to deliver intelligent gaming assistance. Built by 
          an IT professional and gaming enthusiast, this project represents the fusion of two worlds: 
          the joy of gaming and the innovation of modern technology.
        </p>
        <p style={styles.sectionText}>
          From childhood games with grandparents to discovering D&D in the mid-'80s, gaming has been 
          a constant companion. Now, that passion drives this experiment in AI-powered gaming support, 
          leveraging AWS Bedrock and large language models to help fellow gamers overcome obstacles 
          and enhance their experience.
        </p>
      </section>

      {/* Features Preview */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>What You Can Expect</h2>
        <div style={styles.featuresGrid}>
          <div style={styles.featureItem}>
            <h3 style={styles.featureTitle}>Setup Assistance</h3>
            <p style={styles.sectionText}>Get help preparing for your first play session</p>
          </div>
          <div style={styles.featureItem}>
            <h3 style={styles.featureTitle}>Rules Clarification</h3>
            <p style={styles.sectionText}>Navigate complex scenarios and edge cases</p>
          </div>
          <div style={styles.featureItem}>
            <h3 style={styles.featureTitle}>Ongoing Support</h3>
            <p style={styles.sectionText}>Continuous learning and improvement</p>
          </div>
        </div>
      </section>

      {/* Discord Section */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Join Our Community</h2>
        <p style={styles.sectionText}>
          Connect with fellow gamers, share your experiences, and help shape the future of this platform.
        </p>
        <div style={styles.ctaContainer}>
          <DiscordInvite text="Join Our Discord Server" />
        </div>
        <p style={styles.ctaNote}>
          Currently in development • Updates may be sporadic, weekends and holidays
        </p>
      </section>
    </div>
  );
};

export default Home;